module.exports = __webpack_public_path__ + "static/media/tuto-3.0577d9bd.jpg";